// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_1yGF1hcVUis85bnagLONeW","subHeader":"_2B31Stq5nm7FsQPUmTbIR6"};